module.exports = __webpack_public_path__ + "media/bootstrap-icons/volume-mute-6674b7cc.svg";